<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <!--begin::sidebar-->
      <sidebar-component classMenu="AccidentDetail"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
               <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                     Kriminalitas Detail
                  </h6>

                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.create_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.update_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                   <form
                    class="forms-sample"
                    style="padding-left: 25px"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="row mb-2">
                      <div class="col-sm-3">
                        <label class="form-label">Load ID</label>
                      </div>
                      <div class="col-md-8">
                        <!-- <v-select :options="fetchLoadNumber" v-model="loadNumber" label="load_id" return-object
                              @input="getBlujay" @search="asyncSearchLoadNumber"></v-select> -->
                        <input
                          readonly
                          type="text"
                          id="load_id"
                          name="load_id"
                          :value="forms.load_id"
                          class="form-control"
                          placeholder="Load ID"
                        />

                        <div v-if="errors.load_number">
                          <div
                            v-for="error in errors.load_number"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label"
                          >Vehicle No<span class="wajib">*</span></label
                        >
                      </div>
                      <div class="col-md-8">
                        <input
                          readonly
                          type="text"
                          id="load_number"
                          name="load_number"
                          :value="forms.vehicle_no"
                          class="form-control"
                          placeholder="Load ID"
                        />

                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Shipment Date</label>
                      </div>
                      <div class="col-md-8">
                        <!-- <input type="text" id="shipment_date" name="shipment_date" v-model="forms.shipment_date" :disabled="disabledBeforeLoad" class="form-control" placeholder="Shipment Date" /> -->
                       <input
                          readonly
                          type="text"
                          id="load_number"
                          name="load_number"
                          :value="forms.shipment_date"
                          class="form-control"
                          placeholder="Shipment Date"
                        />
                        <div v-if="errors.shipment_date">
                          <div
                            v-for="error in errors.shipment_date"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Order Number</label>
                      </div>
                      <div class="col-md-8">
                        <input
                          type="text"
                          id="order_number"
                          name="order_number"
                          :value="forms.order_number"
                          readonly
                          class="form-control"
                          placeholder="Order Number"
                        />
                        <div v-if="errors.order_number">
                          <div
                            v-for="error in errors.order_number"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label"
                          >Driver NMK<span class="wajib">*</span></label
                        >
                      </div>
                      <div class="col-md-8">
                        <!-- <input type="text" id="vehicle_no" name="vehicle_no" v-model="forms.vehicle_no"
                              class="form-control" placeholder="Vehicle No" readonly /> -->

                        <!-- <v-select
                          :options="fetchDriverNmk"
                          @input="changeDriverNmk(driver_nmk)"
                          v-model="driver_nmk"
                          :disabled="disabledBeforeLoad"
                          label="driver_id"
                          return-object
                          @search="asyncSearchDriverNmk"
                        ></v-select> -->
                         <input
                          type="text"
                          id="driver_nmk"
                          name="driver_nmk"
                          :value="forms.driver_nmk"
                          readonly
                          class="form-control"
                          placeholder="Driver NMK"
                        />

                        <div v-if="errors.driver_nmk">
                          <div
                            v-for="error in errors.driver_nmk"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label"
                          >Driver Name<span class="wajib">*</span></label
                        >
                      </div>
                      <div class="col-md-8">
                        <input
                          type="text"
                          id="driver_name"
                          name="driver_name"
                          v-model="forms.driver_name"
                          class="form-control"
                          placeholder="Driver Name"
                          readonly
                        />
                        <div v-if="errors.driver_name">
                          <div
                            v-for="error in errors.driver_name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Driver HP</label>
                      </div>
                      <div class="col-md-8">
                        <input
                          type="text"
                          id="driver_hp"
                          name="driver_hp"
                          v-model="forms.driver_hp"
                          class="form-control"
                          placeholder="Driver HP"
                          readonly
                        />
                        <div v-if="errors.driver_hp">
                          <div
                            v-for="error in errors.driver_hp"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Kategori</label>
                      </div>
                      <div class="col-md-8">
                        <input
                          type="text"
                          id="category"
                          name="category"
                          :value="forms.category"
                          class="form-control"
                          placeholder="Kategori"
                          readonly
                        />
                        <div v-if="errors.category">
                          <div
                            v-for="error in errors.category"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label"
                          >Date<span class="wajib">*</span></label
                        >
                      </div>
                      <div class="col-md-8">
                         <input
                          type="text"
                          id="date"
                          name="date"
                          :value="forms.date"
                          class="form-control"
                          placeholder="Date"
                          readonly
                        />

                        <div v-if="errors.date">
                          <div
                            v-for="error in errors.date"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Location</label>
                      </div>
                      <div class="col-md-8">
                        <input
                          type="text"
                          id="location"
                          name="location"
                          v-model="forms.location"
                          class="form-control"
                          placeholder="Location"
                          readonly
                        />
                        <div v-if="errors.location">
                          <div
                            v-for="error in errors.location"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Investigation</label>
                      </div>
                      <div class="col-md-8">
                        <textarea
                          name="investigation"
                          class="form-control"
                          v-model="forms.investigation"
                          rows="3"
                          readonly
                        ></textarea>
                        <div v-if="errors.investigation">
                          <div
                            v-for="error in errors.investigation"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Action Plan</label>
                      </div>
                      <div class="col-md-8">
                        <textarea
                          name="action_plan"
                          class="form-control"
                          v-model="forms.action_plan"
                          rows="3"
                          readonly
                        ></textarea>
                        <div v-if="errors.action_plan">
                          <div
                            v-for="error in errors.action_plan"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                       <div class="row mb-2">
                      <div class="col-md-3">
                        <label class="form-label">Date Complete</label>
                      </div>
                      <div class="col-md-8">
                         <input
                          type="text"
                          id="date_complete"
                          name="date_complete"
                          v-model="forms.date_complete"
                          class="form-control"
                          placeholder="Date Complete"
                          readonly
                        />
                        <div v-if="errors.date_complete">
                          <div
                            v-for="error in errors.date_complete"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                     <div class="card-footer">
                  <button
                    class="btn btn-warning text-black fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>
                   <a
                        v-if="permision_role.method_delete"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                  <!-- &nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary float-end btn-sm"
                    type="submit"
                  >
                    <i class="link-icon" data-feather="save"></i>
                    {{ $t("submitFormTxt") }}
                  </button> -->
                </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import DateRangePicker from 'vue2-daterange-picker'
// import "vue2-daterange-picker/dist/vue2-daterange-picker.css";



export default {
  name:"AccidentDetail",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // DateRangePicker
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();
    return {
      opens:"center",
      category:'',
      fetchCategory:[],
      locale:{
        format:"dd mmm yyyy H:MM:ss",
       
      },
      caused:'',
      fetchCaused:[],

      fetchKerusakan: [],
      kerusakans:'',
      fetchTipeKejadian:[],
      tipe_kejadians:'',
      fetchPenyebabDasar:[],
      penyebab_dasars:'',

      accident_date: {
        startDate,
        endDate,
      },

      active_date: {
        startDate,
        endDate,
      },

      accident_date_complete:{
        startDate,
        endDate,
      },



      rate:'',
      fetchRate:[],

      fetchLoadNumber: [],
      loadNumber: [],

      fetchProvinsiTujuan: [],
      ProvinsiTujuan: [],

      fetchKotaTujuan: [],
      KotaTujuan: [],

      fetchSubCustomer: ['Industrial', 'Consumer', 'MT', 'Pallet', 'E-COM'],
      SubCustomer: [],

      showModalUnloading: false,

      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      userData: "",
      companyCode: "",
      forms: {
          master_driver_id:"",
          blujay_order_id:"",
          load_number:"",
          order_detail_id:"",
          order_number:"",
          shipment_date:"",
          customer_id:"",
          customer_name:"",
          master_truck_id:"",
          vehicle_no:"",
          driver_nmk:"",
          driver_name:"",
          driver_id:"",
          driver_hp:"",
          route:"",
      },
      dataModal: {}
    };
  },
  watch: {},
  methods: {
      isNumberLatLong(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetForm() {

    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/kriminalitas/edit/" + params;
    },

    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
         
          const baseURI = this.$settings.endPointCt + "criminality/delete/" + id;
          this.$http
            .delete(baseURI)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/kriminalitas";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },



    backForm() {
      window.location.href = "/kriminalitas";
    },

    loadData(id) {
      this.isLoading = true
      const baseURI = this.$settings.endPointCt + "criminality/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
          this.isLoading = false
          this.forms    = response.data.datas;   

      }).catch(error => {
          this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }else{

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push("/page-not-found");
              }
            }
            
          }


        });
    },


    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'CriminalityController'){
          rolePermision = permision;
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;

    },


    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content{
  filter: blur(5px); 
  pointer-events: none;
}
</style>